import { mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as Api from '../../../../store/bulk/update/bulk.update.api';
import { BulkActions } from '../../../../enums/bulk-actions';

const makeApiCallWithJobId = (job) => {
  const {
    model,
    jobData: { bulkUpdateJobGuid },
  } = job;
  const request = {
    BulkUpdateJobGuid: bulkUpdateJobGuid,
    TaxIdentifierIds: model?.taxIds,
  };

  return Api.bulkUpdateAddTaxIds(request).pipe(
    mergeMap((data) => {
      return of(data);
    }),
  );
};

export const addTaxIdentifiers = {
  id: 'add-tax-idendifier',
  applicableBulkActions: [BulkActions.addTaxIdentifiers],

  handler: (job) => {
    return makeApiCallWithJobId(job);
  },
};
